export type PostTuple = [string, number];

const samePost = (a: PostTuple, b: PostTuple) => a[0] == b[0] && a[1] == b[1];

/**
 * Post list update for a feed the user is currently reading, when only engine data changed (a
 * poll brought new posts, markers were reconciled) — not the feed, sort or filter. The list the
 * user is looking at must not change under them: new posts inserted at the top (newest-first) or
 * posts marked unread elsewhere would shift every index and make the renderers re-render from the
 * top. Such posts only show up once the list is rebuilt on purpose (feed re-entered, sort or filter
 * changed). Two changes are safe and are let through:
 *  - an empty list getting posts (otherwise the user is stuck on "All caught up"),
 *  - pure appends at the end, which the renderers extend without moving the scroll position.
 */
export function freezePostList(prev: PostTuple[], next: PostTuple[]): PostTuple[] {
  if (!prev.length) return next;
  if (next.length >= prev.length && prev.every((p, i) => samePost(p, next[i])))
    return next.length == prev.length ? prev : next;
  return prev;
}
